import styled from "styled-components";
import { panelSpacing } from "../styles";
import colors from "../../config/colors";

export const ProgressBarContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
export const TrackWrapper = styled.div`
  span {
    font-family: "Nunito Sans";
    font-size: 14px;
    font-weight: 400;
    line-height: normal;
  }
`;

export const Track = styled.div`
  width: 170px;
  max-width: 170px;
  height: ${panelSpacing / 4}px;
  background-color: ${colors.secondary};
  border-radius: ${panelSpacing}px;
  margin-bottom: 5px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;
export const Bar = styled.div`
  width: ${(props) => props.percent}%;
  height: ${panelSpacing / 4}px;
  background-color: ${(props) =>
    props.type === "done"
      ? colors.success
      : props.type === "loading"
      ? colors.warning
      : colors.primary};
  transition: all 0.5s ease-in-out;
  border-radius: ${panelSpacing}px;
`;
